export default __webpack_public_path__ + "static/media/Astro_Capricorn_Black.eafaaa9e.png";